import { createAsyncThunk, createSlice, isRejectedWithValue } from "@reduxjs/toolkit";
import { googleAuth } from "services/apis";

const initialState = {
    loading: false,
    success: false,
    error: null,
    auth: {},
    token: null
}


export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload
            localStorage.setItem("tokenf", action.payload)
        },
  setAuth: (state, action) => {
    state.auth = action.payload;
    state.token = action.payload.token;
    localStorage.setItem("tokenf", action.payload.token);
    localStorage.setItem("adminUser", JSON.stringify(action.payload)); // <-- stringify
},

    }
})

export const { setAuth, setToken } = authSlice.actions
export default authSlice.reducer